import { Component, OnDestroy, AfterViewInit, OnChanges, EventEmitter, Input, Output } from '@angular/core';

declare const tinymce: any;

@Component({
  selector: 'app-tiny-editor',
  template: `<textarea id="{{elementId}}">{{richText}}</textarea>`,
  styleUrls: ['./tiny-editor.component.scss']
})
export class TinyEditorComponent implements AfterViewInit, OnDestroy {

  @Input() elementId: String;
  @Input() richText: String;
  @Input() ready: boolean;
  @Output() onEditorKeyup = new EventEmitter<any>();

  public editor;

  ngAfterViewInit() {
    this.initEditor();
  }

  ngOnChanges(changes) {
    if (changes.ready && changes.ready.currentValue === true) {
      tinymce.EditorManager.execCommand('mceRemoveEditor', true, this.elementId);
      tinymce.EditorManager.execCommand('mceAddEditor', true, this.elementId);
      // tinymce.remove(this.editor);
      // this.initEditor();
    }
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }

  private initEditor() {
    let richText = this.richText;

    tinymce.init({
      selector: '#' + this.elementId,
      plugins: ['link', 'paste', 'table', 'lists', 'textcolor'],
      skin_url: '/assets/skins/lightgray',
      setup: editor => {
        this.editor = editor;

        // if (typeof richText === 'string') {
        //   editor.setContent(richText);
        // }
        editor.on('keyup', () => {
          const content = editor.getContent();
          this.onEditorKeyup.emit(content);
        });
      },
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/tiny-editor/tiny-editor.component.ts